import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

const STATION_LIST = ['jiangzhe', 'shanghai', 'chuanyu', 'beijing', 'guangdong', 'total'];

const StationList = (props) => {
    const { content } = props;

    const toNews = (id, isOpen) => {
        if (isOpen) {
            // eslint-disable-next-line no-undef
            window.open(`${linkUrl}/area/${id}`);
        }
    };
    
    return (
        <div className={styles.stationList}>
            {
                content.map((station, index) => {
                    const { id, name, icon, desc, isOpen } = station;

                    return (
                        <div className={`${styles.station} ${isOpen ? '' : styles.disable}`} key={index} onClick={() => toNews(id, isOpen)}>
                            <img className={styles.bc} src={require(`../../../assets/area_${STATION_LIST[id]}${isOpen ? '' : '_dark'}.png`)} alt="" />
                            <div className={styles.stationInfo}>
                                <div className={styles.iconWp}>
                                    <img className={styles.icon} src={icon} alt="" />
                                </div>
                                <div className={`commonTextColor ${styles.name}`}>{name}</div>
                                <div className={styles.divider} />
                                <div className={`commonTextColor ${styles.date}`}>{desc}</div>
                            </div>
                        </div>
                    );
                })
            }
        </div>
    );
};

StationList.propTypes = {
    content: PropTypes.array
};

export default errorBoundary(StationList);
